namespace e5 {
    export interface Encoder {
        encode(ajax: XMLHttpRequest, data: AjaxLoaderData): Promise<any>;
    }

    export interface LoaderEncoderMap {
    }

    type EncoderLookup = {
        [P in keyof LoaderEncoderMap]?: Encoder;
    }

    export const encoders: EncoderLookup = {};

    export function registerEncoder<T extends keyof LoaderEncoderMap>(key: T, encoder: LoaderEncoderMap[T]): void {
        encoders[key] = encoder;
    }

    /**
     * JSON encoder
     */
    class JsonEncoder implements Encoder {
        public async encode(ajax: XMLHttpRequest, data: AjaxLoaderData): Promise<any> {
            ajax.setRequestHeader("Content-Type", "application/x-www-form-urlencoded;charset=UTF-8");

            if (typeof data === "string") {
                return encodeURIComponent("data") + "=" + encodeURIComponent(data);
            }

            var res: string[] = [];
            for (var key in data) {
                res.push(encodeURIComponent(key) + "=" + encodeURIComponent(JSON.stringify(data[key])));
            }
            return res.join("&");
        }
    }

    export interface LoaderEncoderMap {
        "json": JsonEncoder;
    }

    registerEncoder("json", new JsonEncoder());

    /**
     * JSON raw encoder
     */
    class JsonRawEncoder implements Encoder {
        public async encode(ajax: XMLHttpRequest, data: AjaxLoaderData): Promise<any> {
            ajax.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
            return JSON.stringify(data);
        }
    }

    export interface LoaderEncoderMap {
        "jsonraw": JsonRawEncoder;
    }

    registerEncoder("jsonraw", new JsonRawEncoder());

    /**
     * Text encoder
     */
    class TextEncoder implements Encoder {
        public async encode(ajax: XMLHttpRequest, data: AjaxLoaderData): Promise<any> {
            ajax.setRequestHeader("Content-Type", "application/text;charset=UTF-8");
            return String(data);
        }
    }

    export interface LoaderEncoderMap {
        "text": TextEncoder;
    }

    registerEncoder("text", new TextEncoder());
}